
<template>
  <div class="PacientesDetalleGaleriaTratamiento">
    <v-card
      outlined
      :disabled="cargando"
      :loading="cargando"
    >
      <v-card-title>
        Galeria de tratamiento
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            v-for="(g,n) in galeria"
            :key="n"
            class="d-flex child-flex"
            cols="3"
          >
            <v-img
              :src="$raiz + 'uploads/imagenes/' + g.imagen_pag"
              class="grey lighten-2"
              aspect-ratio="1"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import dates from "@/mixins/dates.js";
export default {
  name: "PacientesDetalleGaleriaTratamiento",
  mixins: [forms, dates],
  props: {
    id: [String, Number],
  },
  data() {
    return {
      search: "",
      paciente: null,
      galeria: [],
    };
  },
  methods: {
    _getGaleria() {
      if (this.id) {
        this._getThings("pacientes/galeria/" + this.id, "galeria");
      }
    },
  },
  created() {
    this.paciente = this.id;
    this._getGaleria();
  },
  watch: {
    id() {
      this.paciente = this.id;
      this._getGaleria();
    },
  },
};
</script>

